var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5 38.865C13.7681 38.865 2.35034 48.6727 2.35034 66.4819C2.35034 67.8728 3.47766 69.0001 4.86857 69.0001H64.1313C65.5223 69.0001 66.6496 67.8728 66.6496 66.4819C66.6497 48.6737 55.232 38.865 34.5 38.865ZM7.47844 63.9636C8.46897 50.648 17.5472 43.9016 34.5 43.9016C51.4529 43.9016 60.5312 50.648 61.5226 63.9636H7.47844V63.9636Z",
    fill: "#00A094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5001 0C24.9769 0 17.7958 7.32559 17.7958 17.0394C17.7958 27.0376 25.2893 35.1707 34.5001 35.1707C43.711 35.1707 51.2045 27.0376 51.2045 17.0402C51.2045 7.32559 44.0234 0 34.5001 0ZM34.5001 30.1351C28.066 30.1351 22.8323 24.2608 22.8323 17.0402C22.8323 10.0848 27.7395 5.03646 34.5001 5.03646C41.1526 5.03646 46.168 10.1964 46.168 17.0402C46.168 24.2608 40.9343 30.1351 34.5001 30.1351Z",
    fill: "#00A094"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.3b5e2506746caa3814cdc4a1bf4cfcbd.svg";
export { ForwardRef as ReactComponent };